import { render, staticRenderFns } from "./NumberRound.vue?vue&type=template&id=63391c7e"
import script from "./NumberRound.vue?vue&type=script&lang=js"
export * from "./NumberRound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports